import { render, staticRenderFns } from "./FotoGeneralWebApp.vue?vue&type=template&id=560cff58&scoped=true&"
import script from "./FotoGeneralWebApp.vue?vue&type=script&lang=js&"
export * from "./FotoGeneralWebApp.vue?vue&type=script&lang=js&"
import style0 from "./FotoGeneralWebApp.vue?vue&type=style&index=0&id=560cff58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560cff58",
  null
  
)

export default component.exports